var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { model: _vm.pram, "label-width": "180px" } },
            _vm._l(_vm.tableData.data, function (item, index) {
              return _c(
                "el-form-item",
                {
                  key: index,
                  attrs: { label: _vm.setName(item), prop: "remark" },
                },
                [
                  _vm.orList.includes(item.key)
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: _vm.$t("qxz") },
                              model: {
                                value: item.value,
                                callback: function ($$v) {
                                  _vm.$set(item, "value", $$v)
                                },
                                expression: "item.value",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: _vm.$t("xzxlyc"), value: "1" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: _vm.$t("jglfzxl"), value: "2" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.countryAll.includes(item.key)
                    ? _c(
                        "div",
                        { staticClass: "flex-start" },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              attrs: {
                                action: "",
                                data: { type: item.remark },
                                "http-request": _vm.handleUploadForm,
                                headers: _vm.myHeaders,
                                "show-file-list": false,
                              },
                            },
                            [
                              item.value
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "pictrue",
                                      attrs: { plain: "", type: "success" },
                                    },
                                    [_vm._v("点击更改相应提示音频")]
                                  )
                                : _c("el-button", { staticClass: "upLoad" }, [
                                    _vm._v("点击上传相应提示音频"),
                                  ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "margin_left_12",
                              staticStyle: { width: "100px" },
                              attrs: { placeholder: _vm.$t("qxz") },
                              model: {
                                value: item.status,
                                callback: function ($$v) {
                                  _vm.$set(item, "status", $$v)
                                },
                                expression: "item.status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: _vm.$t("kaiqi"), value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: _vm.$t("guanbi"), value: 0 },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "margin_left_12",
                              staticStyle: { width: "120px" },
                              attrs: { type: "primary", plain: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.listenNote(item)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    item.isPlaying ? "暂停" : _vm.$t("shiting")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog-footer flex-end" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["roleManager:promptSoundSetting:save"],
                      expression: "['roleManager:promptSoundSetting:save']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.submitForm },
                },
                [_vm._v(_vm._s(_vm.$t("trueText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("audio", { ref: "audioPlayer", on: { ended: _vm.onAudioEnded } }),
      _vm._v(" "),
      _c("audio", { ref: "audioPlayerAL", on: { ended: _vm.onAudioEnded } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }